import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton", "loading"]

  submit() {
    this.submitButtonTarget.disabled = true
    this.submitButtonTarget.classList.add("opacity-50", "cursor-not-allowed")
    this.submitButtonTarget.textContent = "Generating..."
    this.loadingTarget.classList.remove("hidden")
  }
}
